module.exports = __webpack_public_path__ + "img/file----------------------------------------1x-png@1x.fab5ec64.png";